import i18n from 'i18next';
import { string } from 'yup';
import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { ROLES } from 'globalconfig/constants/keys';
import { hasRestrictedRole } from 'globalutils/fmUtils';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ fields }) => {
  return {
    form_getData_edit: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => {
        if (hasRestrictedRole([ROLES.UNDER_WRITER, ROLES.LOSS_CONTROL, ROLES.CLAIM_ADJUSTER])) {
          return { zohoCustomerId: fields?.zohoId || null };
        }
        return {};
      },
      default: () => ({}),
    },
    schema_edit: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => {
        if (hasRestrictedRole([ROLES.UNDER_WRITER, ROLES.LOSS_CONTROL, ROLES.CLAIM_ADJUSTER])) {
          return {
            zohoId: string()
              .nullable()
              .max(20, i18n.t('common.max20Char'))
              .matches(/^[a-zA-Z0-9]*$/, i18n.t('common.onlyletterNumber')),
          };
        }
        return {};
      },
      default: () => ({}),
    },

    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
